import { gql } from "@apollo/client";

const CHANGE_UKRAINE_ASSISTANCE_INFO = gql`
mutation ChangeUkraineAssistanceInfo($shelter: String!, $health: String!, $fastTrack: String!, $scholarship: String!, $moreInfoUrl: String!) {
  changeUkraineAssistanceInfo(shelter: $shelter, health: $health, fastTrack: $fastTrack, scholarship: $scholarship, moreInfoUrl: $moreInfoUrl)
}
`;

export default CHANGE_UKRAINE_ASSISTANCE_INFO;
